import React from 'react'
import type { FC, HTMLAttributes } from 'react'
import {Paper} from '../primitives/index.js'

interface HotkeyProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
  elevation?: number
  children: React.ReactNode
}

export const Hotkey: FC<HotkeyProps> = props => {
  const { elevation = 1, children, className } = props

  return (
    <Paper className={className} elevation={elevation} style={{ display: 'flex', color: 'inherit' }}>
      <div
        style={{
          fontSize: 12,
          display: 'flex',
          alignItems: 'center',
          paddingLeft: 8,
          paddingRight: 8,
        }}
      >
        {children}
      </div>
    </Paper>
  )
}

export default Hotkey
